import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { ReportAccessComponent } from "./components/report-access/report-access.component";
import { ReportInventoryComponent } from "./components/report-inventory/report-inventory.component";
import { ReportServiceRequestComponent } from "./components/report-service-request/report-service-request.component";

const routes: Routes = [
  {
    path: "report/service-request",
    component: ReportServiceRequestComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Ordens de Serviço",
    },
  },
  {
    path: "report/inventory",
    component: ReportInventoryComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Ordens de Serviço",
    },
  },
  {
    path: "report/access",
    component: ReportAccessComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Relatório de Acesso",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}
